import React, { Component } from 'react';
import logo from '../../assets/img/logoImpulseGreenColor.png';
import "./index.scss";
import LineDecoration from '../../assets/images/Line decoration.png';
import { AiFillLinkedin } from 'react-icons/ai';
import { CgInstagram } from 'react-icons/cg';
import { MdEmail } from "react-icons/md";
import { ImInstagram } from "react-icons/im";
import { IoLogoWhatsapp } from "react-icons/io";
import { withRouter } from 'react-router-dom'

class NotFound extends Component {
    constructor(props) {
        super(props);
        this.dateRef = React.createRef();
    }


    render() {
        return (
            <div className="container container-fluid my-auto centered-area">
                <div className="text-center">
                        <h2 className="not-found">
                                <span>4</span>
                                <span>0</span>
                                <span>4</span>
                        </h2>
                        <h2 className="mx-auto text-center">Not Found</h2>
                        {/* <p ref={this.dateRef} className="countdown">35 Days</p> */}
                        <div 
                            onClick={() => this.props.history.goBack()}
                            style={{ cursor: 'pointer'}}
                        >
                            <p className="link">Go back to previous page</p>
                        </div>

                </div>
            </div>
        );
    }
}

export default withRouter(NotFound);